import {Button, Paper, Typography} from '@mui/material';
import {motion} from 'framer-motion';
import {signInWithGoogle} from '../../pages/other/LoginPage';

export default function LandingCta() {
  return (
    <Paper
      elevation={3}
      component={motion.div}
      initial={{opacity: 0}}
      whileInView={{opacity: 1}}
      transition={{duration: 0.8}}
      viewport={{once: true}}
      sx={{p: 4, textAlign: 'center', mt: 8, borderRadius: '16px'}}
    >
      <Typography variant="h2" gutterBottom>
        Join Us Today!
      </Typography>
      <Typography variant="body1" gutterBottom sx={{mb: 4, mt: 4}}>
        We are here to help you succeed, and we want your input to shape the tool that will help you sell smarter, not
        harder.
      </Typography>
      <Button
        variant="contained"
        color="primary"
        size="large"
        component={motion.button}
        whileHover={{scale: 1.05}}
        whileTap={{scale: 0.95}}
        onClick={signInWithGoogle}
      >
        🚀 Join Us Now
      </Button>
    </Paper>
  );
}
